import { render, staticRenderFns } from "./GkBadge.vue?vue&type=template&id=53d75716&scoped=true&"
import script from "./GkBadge.vue?vue&type=script&lang=js&"
export * from "./GkBadge.vue?vue&type=script&lang=js&"
import style0 from "./GkBadge.vue?vue&type=style&index=0&id=53d75716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d75716",
  null
  
)

export default component.exports